import apiClient from "@/libs/apiClient"
import { API_URLS } from "./apiUrls"

// export function apiGetProductQnA() {
export function apiGetProductQnA(productId, queryParam) {
  const endpoint = API_URLS.getProductQnAUrl(productId)

  return apiClient.get(endpoint, { params: queryParam })
  // return Promise.resolve({
  //   resultInfo: {
  //     transactionID: "142ce3df-1fae-418f-9254-3fa3228040c8",
  //     statusCode: "200",
  //     message: "OK",
  //     status: "SUCCESS",
  //   },
  //   data: {
  //     page: {
  //       size: 3,
  //       current: 0,
  //       hasNext: true,
  //     },
  //     qnA: [
  //       {
  //         question: {
  //           createdBy: "657bcba3d36af6bb17807cf5",
  //           createdAt: "2024-08-31T14:44:37.000+00:00",
  //           updatedAt: "2024-08-31T14:44:37.000+00:00",
  //           clientId: "jiomart",
  //           productId: "494300182",
  //           productURL:
  //             "http://www.jiomart.com/p/groceries/bharat-rice-10-kg-bag/607768140",
  //           customerName: "-- --",
  //           alternateCode1: "494300182",
  //           alternateCode2: "607768140",
  //           id: "66d32c550af27f095fe6308d",
  //           question: "When it will be available in stock?",
  //           editCount: 0,
  //           approvedAt: "2024-08-31T15:24:37.000+00:00",
  //           reportAbuse: false,
  //           numberOfAnswers: 0,
  //         },
  //         answers: [
  //           // {
  //           //   createdBy: "11508910",
  //           //   createdAt: "2024-09-01T20:52:44.000+00:00",
  //           //   updatedAt: "2024-09-01T20:52:44.000+00:00",
  //           //   clientId: "jiomart",
  //           //   productId: "494300182",
  //           //   productURL:
  //           //     "http://www.jiomart.com/p/groceries/bharat-rice-10-kg-bag/607768140",
  //           //   customerName: "Diwakar Jha",
  //           //   alternateCode1: "494300182",
  //           //   alternateCode2: "607768140",
  //           //   id: "66d4d41cb40c6d73ed3ec9da",
  //           //   answer: "Yes it is , you can check it in the app",
  //           //   questionId: "66d32c550af27f095fe6308d",
  //           //   question: "When it will be available in stock?",
  //           //   upvoteCount: 25,
  //           //   downvoteCount: 37,
  //           //   editCount: 0,
  //           //   verified: true,
  //           //   approvedAt: "2024-09-02T13:37:43.000+00:00",
  //           //   reportAbuse: false,
  //           // },
  //         ],
  //       },
  //       {
  //         question: {
  //           createdBy: "43729643",
  //           createdAt: "2024-07-20T07:05:27.000+00:00",
  //           updatedAt: "2024-07-20T07:05:27.000+00:00",
  //           clientId: "jiomart",
  //           productId: "494300182",
  //           productURL:
  //             "http://www.jiomart.com/p/groceries/bharat-rice-10-kg-bag/607768140",
  //           customerName: "SHRINATH Yoganand",
  //           alternateCode1: "494300182",
  //           alternateCode2: "607768140",
  //           id: "669b61b70829160464e496c2",
  //           question: "Above rice not delivered till now",
  //           editCount: 0,
  //           approvedAt: "2024-07-23T09:22:53.000+00:00",
  //           reportAbuse: false,
  //           numberOfAnswers: 2,
  //         },
  //         answers: [
  //           {
  //             createdBy: "657bcba3d36af6bb17807cf5",
  //             createdAt: "2024-08-17T03:48:21.000+00:00",
  //             updatedAt: "2024-08-17T03:48:22.000+00:00",
  //             clientId: "jiomart",
  //             productId: "494300182",
  //             productURL:
  //               "http://www.jiomart.com/p/groceries/bharat-rice-10-kg-bag/607768140",
  //             customerName: "Aleem Ali",
  //             alternateCode1: "494300182",
  //             alternateCode2: "607768140",
  //             id: "66c01d851bf6194a6da461dd",
  //             answer: "This rice is. Very good to make dosa ,,",
  //             questionId: "669b61b70829160464e496c2",
  //             question: "Above rice not delivered till now",
  //             upvoteCount: 20,
  //             downvoteCount: 12,
  //             editCount: 0,
  //             verified: true,
  //             approvedAt: "2024-08-22T12:09:40.000+00:00",
  //             reportAbuse: false,
  //           },
  //         ],
  //       },
  //       {
  //         question: {
  //           createdBy: "15972415",
  //           createdAt: "2024-07-06T05:48:06.000+00:00",
  //           updatedAt: "2024-07-06T05:48:06.000+00:00",
  //           clientId: "jiomart",
  //           productId: "494300182",
  //           productURL:
  //             "http://www.jiomart.com/p/groceries/bharat-rice-10-kg-bag/607768140",
  //           customerName: "-- --",
  //           alternateCode1: "494300182",
  //           alternateCode2: "607768140",
  //           id: "6688da96e9a5966c24bf322b",
  //           question: "This rice type - mansoori, parmal, mini cut,",
  //           editCount: 0,
  //           approvedAt: "2024-07-06T06:51:12.000+00:00",
  //           reportAbuse: false,
  //           numberOfAnswers: 2,
  //         },
  //         answers: [
  //           {
  //             createdBy: "136581482",
  //             createdAt: "2024-07-11T09:03:41.000+00:00",
  //             updatedAt: "2024-07-11T09:03:41.000+00:00",
  //             clientId: "jiomart",
  //             productId: "494300182",
  //             productURL:
  //               "http://www.jiomart.com/p/groceries/bharat-rice-10-kg-bag/607768140",
  //             customerName: "narendra sidagam",
  //             alternateCode1: "494300182",
  //             alternateCode2: "607768140",
  //             id: "668f9fed5e8e6b0df1c5e8cf",
  //             answer: "Awesome rice i have it last sunday",
  //             questionId: "6688da96e9a5966c24bf322b",
  //             question: "This rice type - mansoori, parmal, mini cut,",
  //             upvoteCount: 82,
  //             downvoteCount: 43,
  //             editCount: 0,
  //             verified: true,
  //             approvedAt: "2024-07-11T09:15:53.000+00:00",
  //             reportAbuse: false,
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // })
}

export function apiUpdateVoteCount(requestData) {
  const endpoint = API_URLS.getQnAUpdateVoteCountUrl()

  return apiClient.put(endpoint, requestData)
}

export function apiAddQuestion(requestData) {
  const endpoint = API_URLS.getAddQuestionUrl()

  return apiClient.post(endpoint, requestData)
}

export function apiAddAnswer(requestData) {
  const endpoint = API_URLS.getAddAnswerUrl()

  return apiClient.post(endpoint, requestData)
}

export function apiGetVerifiedPurchase(articleId) {
  const endpoint = API_URLS.getVerifiedPurchaseUrl(articleId)

  return apiClient.get(endpoint, { useCache: true })
}

// export function apiGetAllAnswersForQuestion() {
export function apiGetAllAnswersForQuestion(questionId) {
  const endpoint = API_URLS.getAllAnswersForQuestionUrl(questionId)

  return apiClient.get(endpoint, { useCache: true })
  // return Promise.resolve({
  //   resultInfo: {
  //     transactionID: "5e3b5106-ce71-42fa-bb3f-76d85d698ede",
  //     statusCode: "200",
  //     message: "OK",
  //     status: "SUCCESS",
  //   },
  //   data: {
  //     question: {
  //       createdBy: "15972415",
  //       updatedBy: "15972415",
  //       createdAt: "2024-07-06T05:48:06.000+00:00",
  //       updatedAt: "2024-07-06T05:48:06.609+00:00",
  //       clientId: "jiomart",
  //       categoryL1: {
  //         id: "2",
  //         name: "Groceries",
  //       },
  //       categoryL2: {
  //         id: "28984",
  //         name: "Cooking Essentials",
  //       },
  //       categoryL3: {
  //         id: "28987",
  //         name: "Rice",
  //       },
  //       categoryL4: {
  //         id: "29472",
  //         name: "Other Rice Varieties",
  //       },
  //       productId: "494300182",
  //       productURL:
  //         "http://www.jiomart.com/p/groceries/bharat-rice-10-kg-bag/607768140",
  //       customerName: "-- --",
  //       alternateCode1: "494300182",
  //       alternateCode2: "607768140",
  //       id: "6688da96e9a5966c24bf322b",
  //       question: "This rice type - mansoori, parmal, mini cut,",
  //       editCount: 0,
  //       approvedBy: "660a575a6936de593e87054f",
  //       approvedAt: "2024-07-06T06:51:12.309+00:00",
  //       reportAbuse: false,
  //       numberOfAnswers: 2,
  //     },
  //     answer: [
  //       {
  //         createdBy: "136581482",
  //         updatedBy: "136581482",
  //         createdAt: "2024-07-11T09:03:41.000+00:00",
  //         updatedAt: "2024-07-11T09:03:41.681+00:00",
  //         clientId: "jiomart",
  //         categoryL1: {
  //           id: "2",
  //           name: "Groceries",
  //         },
  //         categoryL2: {
  //           id: "28984",
  //           name: "Cooking Essentials",
  //         },
  //         categoryL3: {
  //           id: "28987",
  //           name: "Rice",
  //         },
  //         categoryL4: {
  //           id: "29472",
  //           name: "Other Rice Varieties",
  //         },
  //         productId: "494300182",
  //         productURL:
  //           "http://www.jiomart.com/p/groceries/bharat-rice-10-kg-bag/607768140",
  //         customerName: "narendra sidagam",
  //         alternateCode1: "494300182",
  //         alternateCode2: "607768140",
  //         id: "668f9fed5e8e6b0df1c5e8cf",
  //         answer: "Awesome rice i have it last sunday",
  //         questionId: "6688da96e9a5966c24bf322b",
  //         question: "This rice type - mansoori, parmal, mini cut,",
  //         upvoteCount: 82,
  //         downvoteCount: 43,
  //         editCount: 0,
  //         verified: true,
  //         approvedBy: "660a578d1207ed1841eb4542",
  //         approvedAt: "2024-07-11T09:15:53.695+00:00",
  //         reportAbuse: false,
  //       },
  //       {
  //         createdBy: "133511553",
  //         updatedBy: "133511553",
  //         createdAt: "2024-07-11T05:48:25.000+00:00",
  //         updatedAt: "2024-07-11T05:48:25.584+00:00",
  //         clientId: "jiomart",
  //         categoryL1: {
  //           id: "2",
  //           name: "Groceries",
  //         },
  //         categoryL2: {
  //           id: "28984",
  //           name: "Cooking Essentials",
  //         },
  //         categoryL3: {
  //           id: "28987",
  //           name: "Rice",
  //         },
  //         categoryL4: {
  //           id: "29472",
  //           name: "Other Rice Varieties",
  //         },
  //         productId: "494300182",
  //         productURL:
  //           "http://www.jiomart.com/p/groceries/bharat-rice-10-kg-bag/607768140",
  //         customerName: "-- --",
  //         alternateCode1: "494300182",
  //         alternateCode2: "607768140",
  //         id: "668f7229e3fa593111f9473e",
  //         answer: "It is a parmal rice with no fragrance but taste fine",
  //         questionId: "6688da96e9a5966c24bf322b",
  //         question: "This rice type - mansoori, parmal, mini cut,",
  //         upvoteCount: 9,
  //         downvoteCount: 1,
  //         editCount: 0,
  //         verified: true,
  //         approvedBy: "660a578d1207ed1841eb4542",
  //         approvedAt: "2024-07-11T09:16:25.569+00:00",
  //         reportAbuse: false,
  //       },
  //     ],
  //   },
  // })
}
